// 工单和群聊的关联关系
const state = {
  // 处理工单时候接口返回内容(工单内容，人员信息) --- start(接口:/workOrder/handle)
  workOrderGroupInfo: {},
  // 处理工单时候接口返回内容 --- end
  // 待处理数量，处理中数量
  pendingCount: 0,
  processingCount: 0,
  // 当前工单属于（ 2-待处理；3-处理中）
  activeKey: 2,
  // 当前会话ID
  chartId: null,
  // 处理中未读总数量
  processingUnReadCount: 0,
  isGuideConsult: false,
  searchWorkorder: '', // 查询工单标识
  privateGroupMembers: [], // 私聊状态下的群成员列表
  workOrderDetails: new Map(), // 工单详情
  todoListVisible: false, // 通话小结待办
  activeWeComWorkOrderId: '', // 当前正在处理的企微患者会话对应工单 ID
  weComNewMessageWorkOrderMap: {} // 按工单 ID 保存企微新消息提醒
}

const mutations = {
  // 字段设置属性
  SET_ATTR: (state, { key, value }) => {
    if (key in state) {
      state[key] = value
    }
  },
  // 设置工单的 会话信息
  SET_GROUP_INFO(state, info = {}) {
    state.workOrderGroupInfo = info
  },
  // 当前工单是否是导诊咨询类型的工单
  SET_ISGUIDE_CONSULT(state, need = false) {
    state.isGuideConsult = need
  },
  // 设置待处理数量
  SET_PEND_COUNT(state, count) {
    state.pendingCount = count
  },
  // 设置处理中数量
  SET_PROCESS_COUNT(state, count) {
    state.processingCount = count
  },
  // 设置当前处理的是 处理中/待处理
  SET_ACTIVE_KEY(state, key) {
    state.activeKey = key
  },
  // 设置当前会话 ID
  SET_CHART_ID(state, id) {
    state.chartId = id
  },
  SEARCH_WORK_ORDER(state, need = '') {
    state.searchWorkorder = need
  },
  SET_TARGET_WORK_ORDER(state, workOrderId = '') {
    const target = state.workOrderGroupInfo?.dealWorkOrderList.find(
      item => item.workOrderId === workOrderId
    )
    state.workOrderGroupInfo.targetWorkOrder = target
  },
  SET_PRIVATE_MEMBERS(state, members = []) {
    state.privateGroupMembers = members
  },
  SET_PROCESS_UNREADCOUNT(state, num = 0) {
    state.processingUnReadCount = num
  },
  SET_WORK_ORDER_DETAILS(state, details) {
    state.workOrderDetails.set(details.key, details.value)
  },
  SET_TODO_LIST_VISIBLE(state, status) {
    state.todoListVisible = status
  },
  // 收到企微新消息时，当前正在处理的工单不产生提醒
  MARK_WE_COM_NEW_MESSAGE(state, workOrderId) {
    if (!workOrderId || String(workOrderId) === state.activeWeComWorkOrderId) return
    state.weComNewMessageWorkOrderMap = {
      ...state.weComNewMessageWorkOrderMap,
      [String(workOrderId)]: true
    }
  },
  // 进入企微会话时清除该工单已有提醒，离开时传空值
  SET_ACTIVE_WE_COM_WORK_ORDER_ID(state, workOrderId) {
    state.activeWeComWorkOrderId = workOrderId ? String(workOrderId) : ''
    if (!state.activeWeComWorkOrderId) return
    const workOrderMap = { ...state.weComNewMessageWorkOrderMap }
    delete workOrderMap[state.activeWeComWorkOrderId]
    state.weComNewMessageWorkOrderMap = workOrderMap
  }
}
const actions = {
  // 设置工单全部信息
  setAllState({ commit }, obj = {}) {
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        commit('SET_ATTR', { key, value: obj[key] })
      }
    }
  },
  // 设置通话小结待办展示
  setTodoListState({ commit }, todoList = []) {
    const isVisible = todoList.length > 0 ? true : false
    commit('SET_TODO_LIST_VISIBLE', isVisible)
  },
  setAmount({ commit }, { pendingCount, processingCount, key }) {
    commit('SET_PEND_COUNT', pendingCount)
    commit('SET_PROCESS_COUNT', processingCount)
    commit('SET_ACTIVE_KEY', key)
  },
  // 设置待处理或处理中未读数量（先只处理了处理中的）
  /**
   *
   * @param {*} processingUnNum 处理中总数量
   * @param {*} PendingUnNum 待处理总数量（未使用，可扩展）
   */
  setUnReadNum({ commit }, { processingUnNum }) {
    commit('SET_PROCESS_UNREADCOUNT', processingUnNum)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
